/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["vmw",[["AM","PM"],u,["vaasisu","makaaripi"]],[["AM","PM"]],[["S","M","T","W","T","F","S"],["ettiminku","nihiku noolempwa","namaanli","namararu","namaxexe","namathanu","esaabadu"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["janeiru","fevereiru","marsu","abril","maiu","junyu","julyu","agostu","setembru","outubru","novembru","dezembru"]],u,[["BCE","CE"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",",".",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","#,##0.00 ¤","#E0"],u,u,u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
